import $ from 'jquery'

$.fn.readonly = function (val) {
  // Getter. Returns true if attribute is present on first element and
  // false otherwise.
  if (typeof val === 'undefined') {
    const el = this.get(0)
    return el && el.hasAttribute('readonly')
  }

  // Setter. Toggles the attribute on each element in the matched set.
  if (val === 'toggle') {
    return this.each(function () {
      const el = this
      if (el.hasAttribute('readonly')) {
        el.removeAttribute('readonly')
      } else {
        el.setAttribute('readonly', '')
      }
    })
  }

  // Setter. Adds or removes the readonly attribute based on the boolean of
  // the provided value.
  return this.each(function () {
    const el = this
    if (val) {
      el.setAttribute('readonly', '')
    } else {
      el.removeAttribute('readonly')
    }
  })
}
